import i18nstring, { strings } from "../i18n";

export const EMPTY_DELIVERY_SCHEDULE = {
  AM: [],
  PM: []
};

export const EMPTY_EDITOR_ERRORS = {
  deliveryInstructions: "",
  schedule: ""
};

export const normalizeZips = (zips = []) =>
  Array.from(new Set((zips || []).filter(Boolean).map(zip => String(zip))));

export const normalizeSchedule = (deliverySchedule = {}) => ({
  AM: Array.isArray(deliverySchedule?.AM) ? deliverySchedule.AM : [],
  PM: Array.isArray(deliverySchedule?.PM) ? deliverySchedule.PM : []
});

export const createEmptyInstruction = () => ({
  id: null,
  draftKey: null,
  deliveryInstructions: "",
  zips: [],
  deliverySchedule: { ...EMPTY_DELIVERY_SCHEDULE }
});

export const buildInitialPickupStates = (zipList = [], localeMap = new Map()) =>
  zipList.reduce((states, zip) => {
    states[String(zip)] = localeMap.get(String(zip))?.pickupEnabled === true;
    return states;
  }, {});

export const normalizeInstruction = (instruction = {}) => {
  const normalizedZips = normalizeZips(
    instruction.zips || instruction.selectedZips || []
  );

  return {
    ...instruction,
    id: instruction.id || null,
    draftKey: instruction.draftKey || instruction.id || null,
    deliveryInstructions:
      instruction.deliveryInstructions ?? instruction.instructions ?? "",
    zips: normalizedZips,
    deliverySchedule: normalizeSchedule(instruction.deliverySchedule)
  };
};

export const formatScheduleSummary = (deliverySchedule = {}, dayLabels = {}) => {
  const { AM = [], PM = [] } = deliverySchedule;
  const entries = [];

  AM.forEach(day => entries.push(`${dayLabels[day] || day} AM`));
  PM.forEach(day => entries.push(`${dayLabels[day] || day} PM`));

  return entries.length > 0
    ? entries.join(", ")
    : i18nstring(strings.LOCATIONS_NO_HOURS);
};
